import { IconButton } from '@ardoq/button';
import { colors, spacing } from '@ardoq/design-tokens';
import { IconName } from '@ardoq/icons';
import { FlexBox } from '@ardoq/layout';
import { TextOverflow } from '@ardoq/popovers';
import { header2 } from '@ardoq/typography';
import { ReactNode } from 'react';
import styled from 'styled-components';

export const MODAL_HEADER_ID = 'modal-header';
export const MODAL_HEADER_TITLE_ID = 'modal-header-title';

const HeaderWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  padding: ${spacing.s16} ${spacing.s24};
  border-bottom: 1px solid ${colors.borderSubtle};
`;

const HeaderTitle = styled(TextOverflow)`
  ${header2};
  color: ${colors.textDefault};
`;

export interface ModalHeaderProps {
  title?: string;
  onCloseButtonClick?: () => void;
  children?: ReactNode;
  className?: string;
  headerTitleDataTestId?: string;
  closeButtonDataTestId?: string;
  isCloseButtonDisabled?: boolean;
  closeButtonLabel?: string;
}

const ModalHeader = ({
  children,
  title,
  onCloseButtonClick,
  className,
  headerTitleDataTestId,
  closeButtonDataTestId,
  isCloseButtonDisabled,
  closeButtonLabel = 'Close',
}: ModalHeaderProps) => (
  <HeaderWrapper className={className} id={MODAL_HEADER_ID}>
    <FlexBox align="center" justify="space-between" width="full" padding="none">
      <HeaderTitle
        id={MODAL_HEADER_TITLE_ID}
        tabIndex={0}
        role="heading"
        aria-level={1}
        data-test-id={headerTitleDataTestId}
      >
        {title}
        {children}
      </HeaderTitle>
      {onCloseButtonClick && (
        <IconButton
          iconName={IconName.CLOSE}
          onClick={onCloseButtonClick}
          isDisabled={isCloseButtonDisabled}
          label={closeButtonLabel}
          data-test-id={closeButtonDataTestId}
        />
      )}
    </FlexBox>
  </HeaderWrapper>
);

export { ModalHeader };
